import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '@/assets/logos/logo3.png'


const _hoisted_1 = { class: "navbar navbar-expand-md fixed-top navbar-light" }
const _hoisted_2 = { class: "navbar-brand" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = /*#__PURE__*/_createStaticVNode("<div class=\"d-md-none\"><button class=\"navbar-toggler\" type=\"button\" data-toggle=\"collapse\" data-target=\"#navbar-mobile\"><i class=\"icon-tree5\"></i></button><button class=\"navbar-toggler sidebar-mobile-main-toggle\" type=\"button\"><i class=\"icon-paragraph-justify3\"></i></button></div>", 1)
const _hoisted_6 = {
  class: "collapse navbar-collapse",
  id: "navbar-mobile"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("ul", { class: "navbar-nav" }, [
  /*#__PURE__*/_createElementVNode("li", { class: "nav-item" }, [
    /*#__PURE__*/_createElementVNode("a", {
      href: "#",
      class: "navbar-nav-link sidebar-control sidebar-main-toggle d-none d-md-block"
    }, [
      /*#__PURE__*/_createElementVNode("i", { class: "icon-paragraph-justify3" })
    ])
  ])
], -1)
const _hoisted_8 = { class: "navbar-nav ml-auto" }
const _hoisted_9 = { class: "nav-item dropdown" }
const _hoisted_10 = {
  href: "#",
  class: "navbar-nav-link dropdown-toggle caret-0",
  "data-toggle": "dropdown",
  "aria-expanded": "false"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("i", { class: "icon-drive" }, null, -1)
const _hoisted_12 = { class: "d-md-none ml-2" }
const _hoisted_13 = { class: "dropdown-menu dropdown-menu-right" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("i", { class: "icon-drive" }, null, -1)
const _hoisted_15 = /*#__PURE__*/_createTextVNode()
const _hoisted_16 = { class: "nav-item dropdown dropdown-user" }
const _hoisted_17 = {
  href: "#",
  class: "navbar-nav-link d-flex align-items-center dropdown-toggle",
  "data-toggle": "dropdown"
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("i", { class: "d-md-none icon-home2 mr-2" }, null, -1)
const _hoisted_19 = { class: "dropdown-menu dropdown-menu-right" }
const _hoisted_20 = ["onClick"]
const _hoisted_21 = { class: "d-flex flex-row align-items-center" }
const _hoisted_22 = /*#__PURE__*/_createTextVNode()
const _hoisted_23 = { key: 0 }
const _hoisted_24 = /*#__PURE__*/_createTextVNode()
const _hoisted_25 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_26 = { class: "" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", { class: "dropdown-divider" }, null, -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("i", { class: "icon-user-plus" }, null, -1)
const _hoisted_29 = /*#__PURE__*/_createTextVNode(" Accounts verwalten")
const _hoisted_30 = [
  _hoisted_28,
  _hoisted_29
]
const _hoisted_31 = /*#__PURE__*/_createElementVNode("div", { class: "dropdown-divider" }, null, -1)
const _hoisted_32 = /*#__PURE__*/_createElementVNode("i", { class: "icon-cog5" }, null, -1)
const _hoisted_33 = /*#__PURE__*/_createTextVNode(" Logout")
const _hoisted_34 = [
  _hoisted_32,
  _hoisted_33
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("a", {
        href: "",
        class: "d-inline-block",
        onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.$router.push('/')), ["prevent"]))
      }, _hoisted_4)
    ]),
    _hoisted_5,
    _createElementVNode("div", _hoisted_6, [
      _hoisted_7,
      _createElementVNode("ul", _hoisted_8, [
        _createElementVNode("li", _hoisted_9, [
          _createElementVNode("a", _hoisted_10, [
            _hoisted_11,
            _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.viewModeName), 1)
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("a", {
              href: "#",
              class: _normalizeClass(["dropdown-item", _ctx.viewMode=='basic'?'':'text-muted']),
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setNewViewMode('basic')))
            }, [
              _hoisted_14,
              _hoisted_15,
              _createElementVNode("b", null, _toDisplayString(_ctx.viewModes.basic.name), 1)
            ], 2)
          ])
        ]),
        _createElementVNode("li", _hoisted_16, [
          _createElementVNode("a", _hoisted_17, [
            _hoisted_18,
            _createElementVNode("span", null, [
              _createElementVNode("b", null, _toDisplayString(_ctx.user.firstName) + " " + _toDisplayString(_ctx.user.lastName), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_19, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.accounts, (acc, aIndex) => {
              return (_openBlock(), _createElementBlock("a", {
                key: aIndex,
                href: "#",
                class: "dropdown-item",
                onClick: _withModifiers(($event: any) => (_ctx.changeAccount(acc)), ["prevent"])
              }, [
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("i", {
                    class: _normalizeClass(["mr-3", acc.icon])
                  }, null, 2),
                  _createElementVNode("div", null, [
                    _createElementVNode("b", null, _toDisplayString(acc.firstName) + " " + _toDisplayString(acc.lastName), 1),
                    _hoisted_22,
                    (acc.account!=='')
                      ? (_openBlock(), _createElementBlock("small", _hoisted_23, " ( " + _toDisplayString(acc.account) + " )", 1))
                      : _createCommentVNode("", true),
                    _hoisted_24,
                    _hoisted_25,
                    _createElementVNode("span", _hoisted_26, _toDisplayString(acc.email), 1)
                  ])
                ])
              ], 8, _hoisted_20))
            }), 128)),
            _hoisted_27,
            _createElementVNode("a", {
              href: "#",
              class: "dropdown-item",
              onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.linkAccount && _ctx.linkAccount(...args)), ["prevent"]))
            }, _hoisted_30),
            _hoisted_31,
            _createElementVNode("a", {
              href: "#",
              class: "dropdown-item",
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.logout && _ctx.logout(...args)))
            }, _hoisted_34)
          ])
        ])
      ])
    ])
  ]))
}